import React from 'react';
import styled from 'styled-components';
import { WifiOff, RefreshCw } from 'lucide-react';
import { useSystemStatus } from '../../context/SystemStatusContext';

const Container = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #f8f9fa;
  color: #1f2937;
  padding: 20px;
  text-align: center;
`;

const ContentCard = styled.div`
  background: white;
  padding: 48px;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  max-width: 500px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
`;

const IconWrapper = styled.div`
  width: 80px;
  height: 80px;
  background: #fee2e2;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #dc2626;
  margin-bottom: 8px;
`;

const Title = styled.h1`
  font-size: 24px;
  font-weight: 700;
  color: #111827;
  margin: 0;
`;

const Description = styled.p`
  font-size: 16px;
  color: #6b7280;
  line-height: 1.6;
  margin: 0;
`;

const Button = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  background: #2563eb;
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  margin-top: 12px;

  &:hover {
    background: #1d4ed8;
  }

  &:disabled {
    background: #93c5fd;
    cursor: not-allowed;
  }
`;

const ServiceUnavailable = () => {
  const { refreshStatus, isLoading } = useSystemStatus();

  return (
    <Container>
      <ContentCard>
        <IconWrapper>
          <WifiOff size={40} />
        </IconWrapper>
        
        <div>
          <Title>系统服务不可用</Title>
          <div style={{ height: '12px' }} />
          <Description>
            无法连接到服务器，请检查您的网络连接或稍后重试。
            <br />
            如果问题持续存在，请联系技术支持。
          </Description>
        </div>

        <Button onClick={refreshStatus} disabled={isLoading}>
          <RefreshCw size={18} className={isLoading ? "animate-spin" : ""} />
          {isLoading ? '正在重试...' : '重试连接'}
        </Button>
      </ContentCard>
    </Container>
  );
};

export default ServiceUnavailable;
